<mat-toolbar>{{'footers.new' | translate}}</mat-toolbar>
<div class="wizard-wrapper">
  <router-outlet></router-outlet>
</div>
